import * as types from 'modules/vehicleCheckModels/actionTypes';

/**
 * @param {Object} [meta={}]
 * @returns {DetailsPageIsReadyAction}
 */
export const detailsPageIsReady = (meta = {}) => ({
  type: types.DETAILS_PAGE_IS_READY,
  payload: undefined,
  meta,
});
